import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { navigate } from 'gatsby';
import { useStateCode } from '../../state/getStateField';
import {
  ineligibleStates,
  registrationLeoReferralIfWillNotBe18,
  registrationNoStateFormAvailable,
} from './specialCases';

/**
 * To match the Absentee tool flow and design, a custom react hook is used on the
 * Register tool for returning a user to the base registration page if they have
 * navigated to an internal tool page without the proper state being set yet.
 *
 * @param route The name of the internal tool page calling this hook
 * @param tool The identifier for the tool flow we are in. Options are: register, futurevoter
 */
const useRegisterRedirect = (route, tool = 'register') => {
  const [hasTriggered, updateHasTriggered] = useState(false);
  const registerFields = useSelector((state) => state.registerFields);
  const futurevoterFields = useSelector((state) => state.futurevoterFields);
  const fields = tool === 'futurevoter' ? futurevoterFields : registerFields;
  const stateCode = useStateCode();

  useEffect(() => {
    const pagesThatRequireStateCode = [
      'ineligible-age',
      'ineligible-citizenship',
      'ineligible-state',
      'proceed-with-state',
    ];

    // This is here to ensure the hook is only triggered once
    if (!hasTriggered) {
      // All users should go to the homepage of the tool if they don't have a UUID
      // OR if the UUID is set, some routes require that the state code is also set
      // OR if the stateCode is set, one route also requires the state to be ineligible
      // OR always redirect for defunct route(s)
      if (
        !fields.uuid ||
        (!stateCode && pagesThatRequireStateCode.includes(route)) ||
        (route === 'ineligible-state' &&
          !ineligibleStates.includes(stateCode) &&
          !registrationLeoReferralIfWillNotBe18.includes(stateCode) &&
          !registrationNoStateFormAvailable.includes(stateCode))
      ) {
        navigate(`/tools/${tool}/`, { replace: true });
        return;
      }

      updateHasTriggered(true);
    }
  }, [hasTriggered, fields.uuid, stateCode, route, tool]);
};

export default useRegisterRedirect;
